export const DRAG_STATE = 'dragState';
export const DOMAINS = 'domains';

// Domains
export const DOMAIN_PATHWAY_BUILDER_TOOLS_LIST = 'DOMAIN_PATHWAY_BUILDER_TOOLS_LIST';

// Domain properties
export const DOMAIN_PROPERTY_DRAG_STATE = 'dragState';
export const DOMAIN_PROPERTY_DRAG_TYPE = 'dragType';
export const DOMAIN_PROPERTY_DRAG_DATA = 'dragData';

// Action types
export const START_DRAG = 'dragState/START_DRAG';
export const STOP_DRAG = 'dragState/STOP_DRAG';

// Drag types
export const DRAG_TYPE_TOOL_NEW = 'DRAG_TYPE_TOOL_NEW';

// Miscellaneous types
export const TOOL_TYPE_TEXT = 'TOOL_TYPE_TEXT';
export const TOOL_TYPE_IMAGE = 'TOOL_TYPE_IMAGE';
export const TOOL_TYPE_TABLE = 'TOOL_TYPE_TABLE';
export const TOOL_TYPE_COMPONENT = 'TOOL_TYPE_COMPONENT';
export const TOOL_TYPE_BLOCK = 'TOOL_TYPE_BLOCK';
export const TOOL_TYPE_SHOWHIDE = 'TOOL_TYPE_SHOWHIDE';

// Custom events
export const EVENT_DRAGENTER = 'CDPDragStateDragEnter';
export const EVENT_DRAGLEAVE = 'CDPDragStateDragLeave';
export const EVENT_DROP = 'CDPDragStateDrop';
